export default "<app-merch-collection [data]=\"galleryView\" [category]=\"'original'\"></app-merch-collection>\n"